import React from "react";
import {
  AppBar,
  Toolbar,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Stack,
  IconButton,
  Box,
  useMediaQuery,
} from "@mui/material";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  ManageAccounts as ManageAccountsIcon,
} from "@mui/icons-material";
import GroupIcon from "@mui/icons-material/Group";
import { useTheme } from "@mui/styles";

const EventGameToolbar = ({
  eventGameList,
  seletedGameVal,
  setSeletedGameVal,
  handleManageGameTeams,
  handleOpenAddGameDialog,
  handleViewTeamRosters,
  allFiltersSelected,
  classes,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const renderButton = (icon, label, onClick, disabled, startIcon) => {
    return isSmallScreen ? (
      <IconButton color="primary" onClick={onClick} disabled={disabled}>
        {icon}
      </IconButton>
    ) : (
      <Button
        size="small"
        onClick={onClick}
        variant="contained"
        color="primary"
        disabled={disabled}
        startIcon={startIcon}
      >
        {label}
      </Button>
    );
  };

  return (
    <AppBar
      position="sticky"
      className={classes.appbarBackground}
      sx={{ zIndex: "1098" }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Grid container alignItems="center" spacing={2}>
          {/* Title - Visible only on larger screens */}
          <Grid
            item
            lg={6}
            sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          >
            <Typography variant="h6" className={classes.title}>
              Manage Teams Players
            </Typography>
          </Grid>

          {/* Button section */}
          <Grid item lg={6} display="flex" justifyContent="flex-end">
            <Stack direction="row" spacing={2} alignItems="center">
              {/* Game List Select */}
              <Box className="game-list">
                <FormControl variant="standard" sx={{ minWidth: 200 }}>
                  <Select
                    labelId="game-list-select-label"
                    value={seletedGameVal ?? 0}
                    onChange={(e) => setSeletedGameVal(e.target.value)}
                    label="Game List"
                  >
                    {eventGameList?.optionList?.map((item) => (
                      <MenuItem key={item.eventGameId} value={item.eventGameId}>
                        {item.gameName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {/* Manage Game Teams Button */}
              {renderButton(
                <ManageAccountsIcon />,
                "Manage Game Teams",
                handleManageGameTeams,
                !allFiltersSelected,
                <ManageAccountsIcon />
              )}

              {/* Manage Event Games Button */}
              {renderButton(
                <AddCircleOutlineIcon />,
                "Manage Event Games",
                handleOpenAddGameDialog,
                false,
                <AddCircleOutlineIcon />
              )}

              {renderButton(
                <GroupIcon />,
                "View Team Rosters",
                handleViewTeamRosters,
                false,
                <GroupIcon />
              )}
            </Stack>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default EventGameToolbar;
